import CatalogsContent from "./CatalogsContent";

export default CatalogsContent;
